<template>
	<div class="card card-outline m-3">
		<div class="card-header d-flex justify-content-between align-items-center">
			<h3 class="page-title mb-0">Open Commands</h3>

			<div class="d-flex align-items-center">
				<b-form-select
						v-model="selectedSellerIdentifier"
						class="mr-2"
						size="sm"
						style="min-width: 160px;"
				>
					<b-form-select-option disabled :value="''">Verkäufer auswählen</b-form-select-option>
					<b-form-select-option
							v-for="(markets, seller) in activeMarkets"
							:key="seller"
							:value="seller"
					>
						{{ seller }}
					</b-form-select-option>
				</b-form-select>

				<b-form-select
						v-model="selectedMarketPlace"
						:disabled="!selectedSellerIdentifier"
						size="sm"
				>
					<b-form-select-option disabled :value="''">Konto auswählen</b-form-select-option>
					<b-form-select-option
							v-for="market in sortedMarkets"
							:key="selectedSellerIdentifier + '-' +market"
							:value="market"
					>
						{{ market }}
					</b-form-select-option>
				</b-form-select>
			</div>
		</div>


		<div class="card-body p-0">
			<div class="table-responsive">
				<table class="table table-hover table-striped mb-0">
					<thead class="thead-light">
					<tr>
						<th>Priorität</th>
						<th>Typ</th>
						<th>Detailtyp</th>
						<th>Anzahl</th>
					</tr>
					</thead>
					<tbody>
					<tr
							v-for="command in commandData"
							:key="command.key"
							:class="{ 'table-primary': prioritiesForDirectUpdate.includes(Number(command.key)) }"
					>
						<td>{{ command.key }}</td>
						<td>{{ getCommandType(command.key) }}</td>
						<td>{{ getCommandDetail(command.key) }}</td>
						<td>{{ command.value }}</td>
					</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>
<script>
import axios from 'axios';
import { mapState } from 'pinia';
import { toInteger } from 'lodash';

export default {
  name: 'DashboardView',
  data() {
    return {
      selectedSellerIdentifier: "",
      selectedMarketPlace: "",
      activeMarkets: [],
      commandData: [],
			prioritiesForDirectUpdate: [],
    };
  },
  computed: {
    commandPriority() {
        return {
          0: "DEL_COMMAND",
          1: "ADD_WAREHOUSE",
          2: "MOD_RESTOCK_QTY",
					3: "MOD_LOWER_PRICE_MM_HAS_SALE",
					4: "MOD_LOWER_PRICE_MM_NO_SALE",
          5: "MOD_LOWER_PRICE_FROM_GS_WAREHOUSE",
          6: "MOD_HIGHER_PRICE_GS_GT_5",
          7: "MOD_DELIVERY_DOWN_URGENT",
          8: "MOD_DELIVERY_DOWN_STRICT",
          9: "MOD_PRIME_LOSS",
          10: "MOD_DELIVERY_UP",
          11: "MOD_HIGHER_PRICE_MM",
          12: "MOD_LOWER_PRICE_GS_GT_5",
          13: "ADD_NON_BOOK",
          14: "ADD_BOOK",
          15: "MOD_DELIVERY_DOWN_OTHER",
          16: "MOD_DELIVERY_UP_OTHER",
          17: "MOD_LOWER_QTY",
          18: "MOD_HIGHER_QTY",
          19: "MOD_HIGHER_PRICE_FROM_GS_LE_5",
          20: "MOD_LOWER_PRICE_FROM_GS_LE_5",
          10000: "DEFAULT"
        };
    },

    commandTranslation() {
        return {
          "DEL_COMMAND": "Listing löschen",
          "ADD_WAREHOUSE": "Listing hinzufügen (Lager)",
          "ADD_NON_BOOK": "Listing hinzufügen (Non-Book Vendor)",
          "ADD_BOOK": "Listing hinzufügen (Book Vendor)",
          "MOD_RESTOCK_QTY": "Restock ab Menge kleiner 5",
					"MOD_LOWER_PRICE_MM_HAS_SALE": "Unterbieten (mit Verkauf)",
					"MOD_LOWER_PRICE_MM_NO_SALE": "Unterbieten (ohne Verkauf)",
          "MOD_HIGHER_PRICE_MM": "Hochziehen",
          "MOD_HIGHER_PRICE_GS_GT_5": "Preis erhöhen bei min+30 / max (>5%)",
          "MOD_HIGHER_PRICE_FROM_GS_LE_5": "Preis erhöhen bei min+30 / max (≤5%)",
          "MOD_LOWER_PRICE_FROM_GS_WAREHOUSE": "Preis verringern bei min+30 / max (Lager)",
          "MOD_LOWER_PRICE_GS_GT_5": "Preis verringern bei min+30 / max (>5%)",
          "MOD_LOWER_PRICE_FROM_GS_LE_5": "Preis verringern bei min+30 / max (≤5%)",
          "MOD_DELIVERY_DOWN_URGENT": "LK auf 1 oder Prime aktivieren",
          "MOD_DELIVERY_DOWN_STRICT": "LK verbessern (von >3 auf ≤3)",
          "MOD_DELIVERY_DOWN_OTHER": "LK verbessern (sonstige Fälle)",
          "MOD_DELIVERY_UP": "LK stark erhöhen (1–3 → 4+)",
          "MOD_DELIVERY_UP_OTHER": "LK erhöhen (sonstige Fälle)",
          "MOD_PRIME_LOSS": "Prime-Fähigkeit entfernt",
          "MOD_LOWER_QTY": "Menge verringern",
          "MOD_HIGHER_QTY": "Menge erhöhen"
        };
    },
		sortedMarkets() {
			const list = this.activeMarkets[this.selectedSellerIdentifier] || [];
			return [...list].sort((a, b) => a.localeCompare(b));
		}
  },
  watch: {
    selectedMarketPlace(newValue) {
      console.log('Selected Market Place changed:', newValue);
      if (this.selectedSellerIdentifier && newValue) {
        this.fetchCommands();
      }
    }
  },
  methods: {
    getActiveMarkets() {
      console.log('Fetching active markets...');
      axios.get('/ngps/active_markets')
          .then(response => {
            console.log(response);
            this.activeMarkets = response.data;
          })
          .catch(error => {
            console.error('Error fetching commands:', error);
          });
    },
    fetchCommands() {
      axios.get('/ngps/open_command_stats/' + this.selectedSellerIdentifier + '/' + this.selectedMarketPlace)
          .then(response => {
            console.log(response);
						this.commandData = response.data.queueStatsData.countByType;
						this.prioritiesForDirectUpdate = response.data.prioritiesForDirectUpdate;
          })
          .catch(error => {
            console.error('Error fetching commands:', error);
          });
    },
    getCommandType(key) {
      if (key == null) return "-";
      let canLog = false;
      if (key == 0) canLog = true;
      canLog ? console.log(`Command Type for key ${key}:`, this.commandPriority[key]) : null;
      const command = this.commandPriority[key];

      if (!command) return "Unbekannt";

      if (command.startsWith('ADD_')) {
        canLog ? console.log(`Command Type for key ${key} is ADD:`, command) : null;
        return "ADD";
      } else if (command.startsWith('DEL_')) {
        console.log(`Command Type for key ${key} is DEL_:`, command);
        return "DEL";
      } else {
        console.log(`Command Type for key ${key} is MOD:`, command);
        return "MOD";
      }
    },
    getCommandDetail(key) {
      if (key == null || !this.commandPriority[key]) return "Unbekannt";

      const command = this.commandPriority[key];
      return this.commandTranslation[command] || "Unbekannt";
    }
  },
  created() {
    this.getActiveMarkets();
  },
};
</script>